module.exports = __webpack_public_path__ + "static/media/login_avatar.3e038e18.png";